import _ from 'lodash';
import { refClassificationService } from '@/services';
import { GUID_EMPTY } from '@/helpers';
import {
    GET_BY_ACCOUNT_ID,
    GET_BY_ID,
    ADD,
    UPDATE,
    DELETE
} from "./actions.type";
import {
    GET_ALL_REQUEST,
    GET_ALL_SUCCESS,
    GET_ALL_FAILURE,
    GET_BY_ID_REQUEST,
    GET_BY_ID_SUCCESS,
    GET_BY_ID_FAILURE,
    CLEAR_ITEMS,
    CLEAR_CURRENT_ITEM,
    UPDATE_CURRENT_ITEM
} from "./mutations.type";

function getBlankRefClassification() {
    return {
        refClassificationId: GUID_EMPTY,
        accountId: GUID_EMPTY,
        shortName: "",
        name: "",
        notes: "",
        displayOrder: null,
        itServiceCount: 0
    };
}

export const refclassifications = {
    namespaced: true,
    state: {
        status: {
            loading: false,
            loaded: false,
            failed: false,
            error: null
        },
        items: [],
        currentRefClassification: getBlankRefClassification()
    },
    getters: {

    },
    actions: {
        [GET_BY_ACCOUNT_ID]({ commit }, accountId) {
            return new Promise((resolve, reject) => {
                commit(GET_ALL_REQUEST);

                refClassificationService.getByAccount(accountId)
                    .then(
                        refClassifications => {
                            commit(GET_ALL_SUCCESS, refClassifications);
                            resolve(refClassifications);
                        },
                        error => {
                            commit(GET_ALL_FAILURE, error);
                            reject(error);
                        }
                    );
            });
        },
        [GET_BY_ID]({ commit }, refClassificationId) {
            return new Promise((resolve, reject) => {
                commit(GET_BY_ID_REQUEST);

                return refClassificationService.getById(refClassificationId)
                    .then(
                        refClassification => {
                            commit(GET_BY_ID_SUCCESS, refClassification);
                            resolve(refClassification);
                        },
                        error => {
                            commit(GET_BY_ID_FAILURE, error);
                            reject(error);
                        }
                    );
            });
        },
        [ADD]({ dispatch, commit }, refClassification) {
            return refClassificationService.add(refClassification);
        },
        [UPDATE]({ dispatch, commit }, refClassification) {
            return refClassificationService.update(refClassification);
        },
        [DELETE]({ dispatch, commit }, refClassification) {
            return refClassificationService.deleteRefClassification(refClassification);
        },
    },
    mutations: {
        [GET_ALL_REQUEST](state) {
            state.status = { loading: true };
        },
        [GET_ALL_SUCCESS](state, refClassifications) {
            state.status = { loaded: true };
            state.items = refClassifications;
        },
        [GET_ALL_FAILURE](state, error) {
            state.status = { failed: true, error };
            state.items = [];
        },
        [GET_BY_ID_REQUEST](state) {
            state.status = { loading: true };
        },
        [GET_BY_ID_SUCCESS](state, refClassification) {
            state.status = { loaded: true };
            state.currentRefClassification = refClassification;
        },
        [GET_BY_ID_FAILURE](state, error) {
            state.status = { failed: true, error };
            state.currentRefClassification = getBlankRefClassification();
        },
        [CLEAR_ITEMS](state) {
            state.items = [];
        },
        [CLEAR_CURRENT_ITEM](state) {
            state.currentRefClassification = getBlankRefClassification();
        },
        [UPDATE_CURRENT_ITEM](state, { field, value }) {
            // see https://ypereirareis.github.io/blog/2017/04/25/vuejs-two-way-data-binding-state-management-vuex-strict-mode/
            Object.assign(state.currentRefClassification, {
                [field]: value
            });
        },
    }
}
